import React, { useEffect, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { getPageSameType, toTop } from '../../utils/util';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import intl from 'react-intl-universal';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';
import AllForFaceDetectionDialog from '../FaceDetection/AllForFaceDetectionDialog';
import FindDetail from '../../pages/Person/Detail';
import '../../pages/Person/index.scss';

interface IFindButton {
  rootStore?: RootStore;
  children?: any;
}
//
// const findResultRef = window.document.createElement('div');
// findResultRef.className = 'pendant-people-portal';

const FindButton = (props: IFindButton) => {
  const { relationStore } = props.rootStore!;

  const { componentColor, backgroundColor, mainColor } = useContext(
    ThemeContext
  );
  const [pendantBgColor, pendantIconColor] = getPendantColor(mainColor);

  const [showDialog, setShowDialog] = useState(false);
  const [showFindResult, setShowFindResult] = useState(false);

  return (
    <>
      <NormalButton
        className="pendant-find"
        onClick={() => {
          setShowDialog(true);
          stat.event('button_find');
        }}
      >
        <span style={{ fontSize: 12 }}>{props.children ? props.children : intl.get('Find')}</span>
      </NormalButton>
      {showDialog ? (
        <AllForFaceDetectionDialog
          hide={() => setShowDialog(false)}
          success={() => {
            setShowFindResult(true);
          }}
          personStatus={undefined}
          find={true}
        />
      ) : null}
      {/*showFindResult
        ? createPortal(
            <div className="pendant-people-portal">
              <div
                className="pendant-find-result all-for-pageperson"
                style={{ background: componentColor }}
              >
                <FindDetail
                  person={relationStore.find}
                  personAlbum={relationStore.findAlbum}
                  useConfigShare={true}
                />
                <NormalButton
                  className="pendant-back"
                  onClick={() => {
                    setShowFindResult(false);
                  }}
                >
                  {intl.get('Back')}
                </NormalButton>
              </div>
            </div>,
            window.document.getElementById('root-page')! as HTMLDivElement
          )
        : null*/}
    </>
  );
};

export default FindButton;
